export const model = {
  id: null,
  name: '',
  created_at: '',
  updated_at: '',
};
